import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Dropdown, Image } from 'react-bootstrap';
import { useFieldArray, useFormContext } from 'react-hook-form';
import config from 'config';
import BasePrompt from 'components/base/prompt/BasePrompt';
import DeleteIcon from 'assets/images/deleteIcon.png';
import {
  DISPLAY_EARNING_RULE_LINE_ITEM_GROUP_REQUIREMENT_TYPE,
  EARNING_RULE_LINE_ITEM_GROUP_REQUIREMENT_TYPE
} from 'config/CustomEnums';
import GeneralPurchasePerMin from './GeneralPurchasePerMin';
import { RequirementBaseDropdown } from './LineItemGroupRequirements';
import InputFieldControl from 'components/base/InputFieldControl';
import './SingleLineItemGroup.scss';

const multipleRequirementSections = [
  EARNING_RULE_LINE_ITEM_GROUP_REQUIREMENT_TYPE.transactionAdditionalData,
  EARNING_RULE_LINE_ITEM_GROUP_REQUIREMENT_TYPE.purchasedItemAdditionalData,
];

const requirementSections = [
  EARNING_RULE_LINE_ITEM_GROUP_REQUIREMENT_TYPE.brand,
  EARNING_RULE_LINE_ITEM_GROUP_REQUIREMENT_TYPE.category,
  EARNING_RULE_LINE_ITEM_GROUP_REQUIREMENT_TYPE.subcategory,
  EARNING_RULE_LINE_ITEM_GROUP_REQUIREMENT_TYPE.transactionAdditionalData,
  EARNING_RULE_LINE_ITEM_GROUP_REQUIREMENT_TYPE.purchasedItemAdditionalData,
  EARNING_RULE_LINE_ITEM_GROUP_REQUIREMENT_TYPE.sku,
];

const relationshipList = [
  {
    label: "AND",
    value: false,
  },
  {
    label: "OR",
    value: true,
  }
];

const RequirementFilterDropDown = ({
  show,
  addRequirement,
  settedRequirement,
}) => {
  const [requirementSelections, setRequirementSelections] = useState(requirementSections);

  const setValidRequirement = (requirementList) => {
    setRequirementSelections(requirementSections.filter(item => (
      multipleRequirementSections.includes(item)
      || !requirementList.includes(item)
    )
    ))
  };

  useEffect(() => {
    setValidRequirement(settedRequirement);
  }, [settedRequirement]);

  return (
    <div className="content-add-button-selection-area">
      <div className="content-add-button-selection-section-area">
        {requirementSelections.map((section) => {
          return (
            <div key={`requirement-selection-${section}`}>
              <Dropdown.Item
                onClick={() => {
                  addRequirement(section);
                }}
              >
                <div className="display-flex-area">
                  <label className="li-label">{DISPLAY_EARNING_RULE_LINE_ITEM_GROUP_REQUIREMENT_TYPE[section]}</label>
                </div>
              </Dropdown.Item>
            </div>
          );
        })}
      </div>
    </div>
  );
}

const SingleLineItemGroup = ({
  productSkus,
  index,
  removeGroup,
  prefix="",
}) => {
  const {
    control,
    register,
    formState: { errors },
    watch,
    setValue,
  } = useFormContext();
  const groupIndex = index + 1;
  const requirementsName = `${prefix}lineItemGroups.${index}.requirements`;
  const lineITemGroupsUseOrName = `${prefix}lineITemGroupsUseOr`;

  const watchLineITemGroupsUseOr = watch(lineITemGroupsUseOrName);
  const { fields, append, remove, replace } = useFieldArray({
    control,
    name: requirementsName,
  });
  const [showResetPrompt, setShowResetPrompt] = useState(false);
  const [isShowDropdown, setIsShowDropdown] = useState(false);

  const requirementComponment = {
    [EARNING_RULE_LINE_ITEM_GROUP_REQUIREMENT_TYPE.brand]: {
      component: RequirementBaseDropdown,
      componentProps: {
        title: "Select brand",
        modelName: 'brand',
        sourceListName: 'brandList',
        labelContainPk: true,
        loadMoreAction: 'brand/getCurrentPageBrands',
        filterAction: 'brand/getCurrentPageBrands',
        defaultFilter: {
          moreSearch: {
            searchField: 'searchNameOrId',
          },
        },
        placeholder: "Search by name or id",
      },
    },
    [EARNING_RULE_LINE_ITEM_GROUP_REQUIREMENT_TYPE.category]: {
      component: RequirementBaseDropdown,
      componentProps: {
        title: "Select category",
        modelName: 'productCategoryList',
        sourceListName: 'productCategoryAllList',
        labelContainPk: true,
        loadMoreAction: 'productCategoryList/getPagedProductCategories',
        filterAction: 'productCategoryList/getPagedProductCategories',
        defaultFilter: {
          sort: '-pk',
          searchNameOrId: true,
        },
        placeholder: "Search by name or id",
      },
    },
    [EARNING_RULE_LINE_ITEM_GROUP_REQUIREMENT_TYPE.subcategory]: {
      component: RequirementBaseDropdown,
      componentProps: {
        title: "Select subcategory",
        modelName: 'productCategoryList',
        sourceListName: 'productSubcategoryAllList',
        labelContainPk: true,
        loadMoreAction: 'productCategoryList/getPagedProductSubcategories',
        filterAction: 'productCategoryList/getPagedProductSubcategories',
        defaultFilter: {
          sort: '-pk',
          searchNameOrId: true,
        },
        placeholder: "Search by name or id",
      },
    },
    [EARNING_RULE_LINE_ITEM_GROUP_REQUIREMENT_TYPE.transactionAdditionalData]: {
      component: RequirementBaseDropdown,
      componentProps: {
        title: "Select title (additional data from transaction records)",
        modelName: 'transactions',
        sourceListName: 'transactionAdditionalDataList',
        labelContainPk: false,
        loadMoreAction: 'transactions/getPagedTransactionAdditionDataFields',
        filterAction: 'transactions/getPagedTransactionAdditionDataFields',
      },
    },
    [EARNING_RULE_LINE_ITEM_GROUP_REQUIREMENT_TYPE.purchasedItemAdditionalData]: {
      component: RequirementBaseDropdown,
      componentProps: {
        title: "Select title (additional data from purchased items)",
        modelName: 'transactions',
        sourceListName: 'purchasedItemAdditionalDataList',
        labelContainPk: false,
        loadMoreAction: 'transactions/getPagedPurchasedItemAdditionDataFields',
        filterAction: 'transactions/getPagedPurchasedItemAdditionDataFields',
      },
    },
    [EARNING_RULE_LINE_ITEM_GROUP_REQUIREMENT_TYPE.sku]: {
      component: InputFieldControl,
      componentProps: {
        useDefaultFieldName: true,
        title: "Select sku",
        className: "coupon-campaign-section-input line-item-group-sku-section",
      },
    },
    skuDropDown: {
      component: RequirementBaseDropdown,
      componentProps: {
        title: "Select sku",
        modelName: 'shopify',
        sourceListName: 'productSkus',
        labelContainPk: false,
      },
    },
  }

  const getFieldName = (fieldType, subIndex) => {
    const formErrorId = `${prefix}lineItemGroups.${index}.requirements.${subIndex}.error`;
    if ([
      EARNING_RULE_LINE_ITEM_GROUP_REQUIREMENT_TYPE.brand,
      EARNING_RULE_LINE_ITEM_GROUP_REQUIREMENT_TYPE.category,
      EARNING_RULE_LINE_ITEM_GROUP_REQUIREMENT_TYPE.subcategory,
    ].includes(fieldType)) {
      return {
        formErrorId,
        valueFieldName: `${prefix}lineItemGroups.${index}.requirements.${subIndex}.data`
      };
    };
    if ([
      EARNING_RULE_LINE_ITEM_GROUP_REQUIREMENT_TYPE.transactionAdditionalData,
      EARNING_RULE_LINE_ITEM_GROUP_REQUIREMENT_TYPE.purchasedItemAdditionalData,
    ].includes(fieldType)) {
      return {
        formErrorId,
        valueFieldName: `${prefix}lineItemGroups.${index}.requirements.${subIndex}.data.field`,
        isAdditionalData: true,
        additionalTitle:
          fieldType === EARNING_RULE_LINE_ITEM_GROUP_REQUIREMENT_TYPE.transactionAdditionalData
            ? "Select value (additional data from transaction records)"
            : "Select value (additional data from purchased items)",
        additionalName: `${prefix}lineItemGroups.${index}.requirements.${subIndex}.data.value`,
      };
    };
    if (fieldType === EARNING_RULE_LINE_ITEM_GROUP_REQUIREMENT_TYPE.sku) {
      return {
        formErrorId,
        errorId: formErrorId,
        name: `${prefix}lineItemGroups.${index}.requirements.${subIndex}.data`,
        isSku: true,
        valueFieldName: `${prefix}lineItemGroups.${index}.requirements.${subIndex}.data`,
      };
    };

    return {};
  }

  return (
    <>
      <div className="content-area">
        <div className="title-in-block">
          <label className="create-section-title">
            Line item group {groupIndex}
          </label>
          {fields.length > 0 ? (
            <button
              type="button"
              className="btn-link reset-button"
              onClick={() => setShowResetPrompt(true)}
            >
              Reset
            </button>
          ) : null}
          <button
            className="delete-condition-group-button"
            type="button"
            onClick={() => {
              replace([]);
              removeGroup(index);
            }}
          >
            <Image src={DeleteIcon} className="content-delete-button" />
          </button>
        </div>
        {fields.map((item, subIndex) => {
          let requirementConfig = requirementComponment[item.fieldType];
          if (
            item.fieldType === EARNING_RULE_LINE_ITEM_GROUP_REQUIREMENT_TYPE.sku
            && config.generalPurchaseEarningRuleUseShopifySku
            && productSkus?.length
          ) {
            requirementConfig = requirementComponment["skuDropDown"];
          };
          return (
            <div key={`requirement-${index}-${subIndex}`}>
              <div className="display-flex-area and-requirement-container">
                {requirementConfig && (
                  <div className='single-requirement-container'>
                    <requirementConfig.component
                      {...getFieldName(item.fieldType, subIndex)}
                      {...requirementConfig.componentProps}
                    />
                  </div>
                )}
                <button
                  className="reset-button content-delete-button-area"
                  type="button"
                  onClick={() => {
                    remove(subIndex);
                  }}
                >
                  <Image src={DeleteIcon} className="content-delete-button" />
                </button>
              </div>
              <div className="content-condition-area">
                <div className="content-condition-dash"></div>
                <label>AND</label>
              </div>
            </div>
          );
        })}
        <Dropdown
          onToggle={(isOpen) => {
            setIsShowDropdown(isOpen);
          }}
        >
          <Dropdown.Toggle
            className="btn-back-button-common content-add-button"
            variant="none"
            id={`dropdown-${groupIndex}`}
          >
            + Add requirement
          </Dropdown.Toggle>

          <Dropdown.Menu style={{ zIndex: 2 }}>
            <RequirementFilterDropDown
              show={isShowDropdown}
              addRequirement={(section) => {
                append({ fieldType: section });
              }}
              settedRequirement={fields?.map((item) => item.fieldType)}
            />
          </Dropdown.Menu>
        </Dropdown>

        <GeneralPurchasePerMin
          containerClassName='general-purchase-per-line-item-container'
          minSpendingTitle="Minimum spending per line item (optional)"
          minSpendingName={`${prefix}lineItemGroups.${index}.minimumSpending`}
          minQuantityTitle="Minimum quantity per line item (optional)"
          minQuantityName={`${prefix}lineItemGroups.${index}.minimumQuantity`}
        />
      </div>

      <div className="content-line-item-group-relationship-container">
        <div className="content-condition-dash"></div>
        <div className="content-relationship-container">
          {
            relationshipList.map(item => (
              <div
                key={`relationship-${item.label}`}
                className={`content-relationship-item ${item.value == !!watchLineITemGroupsUseOr ? 'selected' : ''}`}
                onClick={() => {
                  setValue(lineITemGroupsUseOrName, item.value, { shouldDirty: true })
                }}
              >
                <span>{item.label}</span>
              </div>
            ))
          }
        </div>
      </div>

      <BasePrompt
        show={showResetPrompt}
        title={`Reset line item group ${groupIndex}`}
        description={'Did you confirm to reset this line item group?'}
        closeAction={() => setShowResetPrompt(false)}
        leftButton={{
          text: 'Cancel',
          action: () => {
            setShowResetPrompt(false);
          },
        }}
        rightButton={{
          text: 'Delete',
          action: () => {
            replace([]);
            setShowResetPrompt(false);
          },
        }}
      />
    </>
  )
}

const mapStateToProps = (state) => ({
  productSkus: state.shopify.productSkus,
})

export default connect(mapStateToProps)(SingleLineItemGroup);
